import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dd24e3b2"
import script from "./reportModal?vue&type=script&lang=js&external"
export * from "./reportModal?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports